import { get } from 'lodash';
import { throwError } from '../utils/env';

export class LogoConfig {

  static DEFAULT_APP_LOGO_CODE = '2simple';

  _logosInfo;

  _logosPath;

  _customModuleLogosPath;

  constructor(
    logosPath = '/dist/static/logos/logos.json',
    customModuleLogosPath = '/dist/static/logos/custom-module-preview-logos'
  ) {
    this._logosPath = logosPath;
    this._customModuleLogosPath = customModuleLogosPath;
  }

  loadLogosInfo = async () => {
    try {
      this._logosInfo = await $.ajax({
        url: this._logosPath,
        contentType: 'application/json',
        headers: {
          'Accept': 'text/json'
        }
      });
    } catch (error) {
      throwError(error && error.message);
    }
  }

  getAppLogo(moduleCode) {
    return get(this._logosInfo, `app-logos.${moduleCode || LogoConfig.DEFAULT_APP_LOGO_CODE}`);
  }

  getModulePreviewLogo(moduleCode) {
    return get(this._logosInfo, `module-preview-logos.${moduleCode}`);
  }

  getModuleLogo(moduleCode) {
    return get(this._logosInfo, `module-logos.${moduleCode}`);
  }

  getCustomModulePreviewLogoHTML(moduleCode) {
    return `${this._customModuleLogosPath}/${moduleCode}.html`;
  }

}
